import {Message} from 'element-ui';

const MessageService = {

    success: (message, showClose = true) => Message({showClose, type: "success", message}),

    error: (message, showClose = true) => Message({showClose, type: "error", message})
}

export default MessageService;
